import { Injectable } from '@angular/core';
import { AppVariables, ErrorCodes, RegistrationVariables } from '@shared';
import { LoggingService } from '@shared/logging';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class EncryptionService {
	public constructor(private loggingService: LoggingService) {}

	public encrypt(value: string): string {
		try {
			return CryptoJS.SHA256(`${value}${RegistrationVariables.LOCAL_CREDENTIALS_SALT}`).toString();
		} catch (error) {
			this.loggingService.error(ErrorCodes.RegistrationEncryptCredentialsError, error);
			throw new Error('Encrypting credentials failed');
		}
	}

	public decrypt(encryptedText: string) {
		const keyBytes = CryptoJS.enc.Utf8.parse(AppVariables.ENCRYPTION_KEY);
		const ivBytes = CryptoJS.enc.Utf8.parse(AppVariables.ENCRYPTION_iv);
		const ciphertext = CryptoJS.enc.Base64.parse(encryptedText).toString(CryptoJS.enc.Base64);

		const decrypted = CryptoJS.AES.decrypt(ciphertext, keyBytes, {
			iv: ivBytes,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});

		const decriptedString = decrypted.toString(CryptoJS.enc.Utf8);
		if (!decriptedString) {
			this.loggingService.error(
				'Decryption Failed',
				'The provided encrypted text could not be decripted ' + encryptedText
			);
			throw new Error('Decrypting apiKey failed');
		}

		return decriptedString;
	}
}
